const { setTimeout } = require("core-js");

var utils = {

    BASE_API:"",
    TOKEN:"",
    SESSION_TOKEN:"",
    TIMEOUT_SESSIONE:0,
    INIZIO_SESSIONE:0,
    API_TOKEN:"",
    deltaGriglia:0,
    RELOAD_SESSIONE_SCADUTA:0,
    appoggio:{},


    ajax : function(_api,_args,_handler,_showBar = true,_flgGestioneEsito = 0,_method = null){
        _method = (_method == undefined || _method == null) ? "POST" : _method;
        if (_showBar == true ){
            global.utils.blockPage();
        }
        _args.SESSION_TOKEN = global.utils.SESSION_TOKEN; //'tvnqs0iv0q8b8qft9n1dds9ra7'; //
        /*
        const apiUrl = 'https://api.example.com/users/123';
        // Make a GET request using the Fetch API
        fetch(apiUrl)
        .then(response => {
            if (!response.ok) {
            throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(userData => {
            // Process the retrieved user data
            console.log('User Data:', userData);
        })
        .catch(error => {
            console.error('Error:', error);
        });
        */ 
        fetch( global.utils.BASE_API + _api, {
            method: _method,
            body: JSON.stringify(_args),            
            headers:  {'Accept': 'application/json',
                        'Content-Type': 'application/json',
                      },
                      //credentials: 'include'
        })
        .then(response => response.json()) 
        .then(data => {
            if (_showBar == true ){
                global.utils.unblockPage();
            }
            if (data.esito == 0){
                if (global.sprint && global.sprint._instance && global.sprint._instance.proxy.$root) {
                    global.sprint._instance.proxy.$root.resetSessionTimer();
                }
                if (data['arrayCampi'] != undefined && data['compressed'] != undefined){
                    data.data = global.utils.getArrayFromJSON(data.arrayCampi,data.data);
                }
                _handler(data);
            }
            else{
                //SESSIONE UTENTE SCADUTA
                if (data.esito == 401){                       
                    if (global.utils.RELOAD_SESSIONE_SCADUTA == 1){
                        //global.utils.alert.standard("Sessione utente scaduta");
                        global.sprint._component.methods.startHandler();
                    }
                    else{
                        global.sprint._component.methods.startHandler();
                    }
                }
                //FORCE LOGOUT
                else if(data.esito == 999){
                    global.utils.blockPage();
                    setTimeout(() => {
                        global.utils.alert.standard(data.messaggio);
                    }, 500);
                    setTimeout(() => {
                        window.location.href = global.utils.BASE_API + "core/logout";
                    }, 3000);
                }
                if (_flgGestioneEsito == undefined || _flgGestioneEsito == 0){
                    global.utils.alert.warning(data.messaggio);
                }
                else{
                    _handler(data);
                }
            }
        })
        .catch(err => {
            global.utils.alert.danger("Si è verificato un errore");
            console.error(err);            
            if (_showBar == true ){
                global.utils.unblockPage();
            }
        });
    },

    /*
    ajax_old : function(_api,_args,_handler,_showBar = true,_flgGestioneEsito = 0,_method = null){

        _handler({esito:0,data:{},messaggio:'ok'});
        return
        _method = (_method == undefined || _method == null) ? "POST" : _method;
        if (_showBar == true ){
            global.utils.blockPage();
        }
        _args.SESSION_TOKEN = global.utils.SESSION_TOKEN;
        //_args.FROM = 'deskalo';
        global.$.ajax({
			type: _method,
			data: _args,
			url: global.utils.BASE_API + _api,
			cache: false,
			dataType: 'json',
			success: function (data) {
                if (_showBar == true ){
                    global.utils.unblockPage();
                }
                if (data.esito == 0){
                    if (data['arrayCampi'] != undefined && data['compressed'] != undefined){
                        data.data = global.utils.getArrayFromJSON(data.arrayCampi,data.data);
                    }
                    _handler(data);
                }
                else{
                    //SESSIONE UTENTE SCADUTA
                    if (data.esito == 401){                       
                        if (global.utils.RELOAD_SESSIONE_SCADUTA == 1){
                            //global.utils.alert.standard("Sessione utente scaduta");
                            global.sprint._component.methods.startHandler();
                        }
                        else{
                            global.sprint._component.methods.startHandler();
                        }
                    }
                    //FORCE LOGOUT
                    else if(data.esito == 999){
                        global.utils.blockPage();
                        setTimeout(() => {
                            global.utils.alert.standard(data.messaggio);
                        }, 500);
                        setTimeout(() => {
                            window.location.href = global.utils.BASE_API + "core/logout";
                        }, 3000);
                    }
                    if (_flgGestioneEsito == undefined || _flgGestioneEsito == 0){
                        global.utils.alert.warning(data.messaggio);
                    }
                    else{
                        _handler(data);
                    }
                }
            },
            error: function( jqXHR,  textStatus, errorThrown ){
                global.utils.alert.danger("Si è verificato un errore");
                console.error(jqXHR,textStatus,errorThrown);
                if (jqXHR.status == 0){
                   // global.utils.stopSocket();
                }
                if (_showBar == true ){
                    global.utils.unblockPage();
                }
            }
		});
    },
    */
    
    ajaxText: function (_api, _args, _handler, _showBar = true, _method = 'GET') {
        if (_showBar) global.utils.blockPage();

        _args.SESSION_TOKEN = global.utils.SESSION_TOKEN;

        const url = global.utils.BASE_API + _api;

        const fetchOptions = {
            method: _method,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        };

        // Serializza i parametri
        const urlParams = new URLSearchParams(_args).toString();

        if (_method.toUpperCase() === 'GET') {
            fetch(url + '?' + urlParams, fetchOptions)
                .then(response => response.text())
                .then(text => {
                    if (_showBar) global.utils.unblockPage();
                    _handler(text);
                })
                .catch(error => {
                    global.utils.alert.danger("Errore nel caricamento del file");
                    console.error(error);
                    if (_showBar) global.utils.unblockPage();
                });
        } else {
            fetchOptions.body = urlParams;

            fetch(url, fetchOptions)
                .then(response => response.text())
                .then(text => {
                    if (_showBar) global.utils.unblockPage();
                    _handler(text);
                })
                .catch(error => {
                    global.utils.alert.danger("Errore nel caricamento del file");
                    console.error(error);
                    if (_showBar) global.utils.unblockPage();
                });
        }
    },

    ajaxBlob: function (_api, _args, _handler, _showBar = true, _method = 'GET') {
        if (_showBar) global.utils.blockPage();

        _args.SESSION_TOKEN = global.utils.SESSION_TOKEN;

        const url = global.utils.BASE_API + _api;
        const fetchOptions = {
            method: _method,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        };

        const urlParams = new URLSearchParams(_args).toString();

        const doFetch = (_url, _options) => {
            fetch(_url, _options)
                .then(response => {
                    if (!response.ok) throw new Error("Errore HTTP: " + response.status);
                    return response.blob(); // 👈 Riceviamo direttamente un blob
                })
                .then(blob => {
                    if (_showBar) global.utils.unblockPage();
                    _handler(blob); // 🔁 Passa il blob ricevuto
                })
                .catch(error => {
                    global.utils.alert.danger("❌ Errore durante il caricamento blob");
                    console.error(error);
                    if (_showBar) global.utils.unblockPage();
                });
        };

        if (_method.toUpperCase() === 'GET') {
            doFetch(`${url}?${urlParams}`, fetchOptions);
        } else {
            fetchOptions.body = urlParams;
            doFetch(url, fetchOptions);
        }
    },


    connect : function(address,root,protocollo,handler,flgAutenticazione = 0){
        utils.blockPage();
        root.connessioneSocket = 0;

        // Ottieni token JWT per autenticazione socket
        const token = global.utils.API_TOKEN;

        if (!token) {
            console.error('Cannot connect socket: no auth token available');
            utils.unblockPage();
            if (root.isGod) utils.alert.danger("Impossibile connettersi: token di autenticazione mancante","Errore","",5000);
            return;
        }

        root.appoggio.socket = io(address, {
            path: "/socket.io",
            //transports: ['websocket', 'polling', 'flashsocket'],
            transports: ['websocket'],
            timeout:3000,
            auth: {
                token: token
            }
        });
        root.appoggio.socket.on('connect', () => {
            root.connessioneSocket = 1;
            utils.unblockPage();
            if (root.isGod) utils.alert.success("Connessione socket stabilita","Attenzione","",5000);
            console.info("CONNESSIONE SOCKET AVVENUTA");
            handler();
        });
        root.appoggio.socket.on('connect_error', (err) => {
            utils.unblockPage();
            if (err.message.includes('Authentication')) {
                console.error('Socket authentication failed:', err.message);
                if (root.isGod) utils.alert.danger("Autenticazione socket fallita","Errore","",5000);
            } else {
                console.error('Socket connection error:', err.message);
                if (root.isGod) utils.alert.danger("Errore di connessione socket","Errore","",5000);
            }
        });
        root.appoggio.socket.on('disconnect', (args) => {
            root.connessioneSocket = 0;
            if (root.isGod) utils.alert.danger("Connessione socket persa","Attenzione","",5000);
            utils.unblockPage();
            console.info("DISCONNESSIONE SOCKET AVVENUTA");
            if (root.appoggio.hasOwnProperty('mascheraCorrente')){
                if (typeof root.appoggio.mascheraCorrente.disconnessioneSocket == 'function'){
                    root.appoggio.mascheraCorrente.disconnessioneSocket()
                }
            }
        });
        root.appoggio.socket.on('error', (args) => {
            utils.unblockPage();
            console.log(args);
            if (root.appoggio.hasOwnProperty('mascheraCorrente')){
                if (typeof root.appoggio.mascheraCorrente.disconnessioneSocket == 'function'){
                    root.appoggio.mascheraCorrente.disconnessioneSocket()
                }
            }
        });
    },    
    
    upload : function(_api,_args,_handler,_showBar = true,_flgGestioneEsito = 0,_method = null){
        _method = (_method == undefined || _method == null) ? "POST" : _method;
        if (_showBar == true ){
            global.utils.blockPage();
        }
        console.log("**uploading");
        _api += "?SESSION_TOKEN="+global.utils.SESSION_TOKEN;
        utils.ajax({
			type: _method,
			data: _args,
			url: global.utils.BASE_API + _api,
			cache: false,
            processData: false,
            contentType: false,
            enctype: 'multipart/form-data',
			success: function (data) {
                if (_showBar == true ){
                    global.utils.unblockPage();
                }
                if (data.esito == 0){
                    if (data['arrayCampi'] != undefined && data['compressed'] != undefined){
                        data.data = global.utils.getArrayFromJSON(data.arrayCampi,data.data);
                    }
                    _handler(data);
                }
                else{
                    //SESSIONE UTENTE SCADUTA
                    if (data.esito == 401){
                        if (global.utils.RELOAD_SESSIONE_SCADUTA == 1){
                            //global.utils.alert.standard("Sessione utente scaduta");
                            global.sprint._component.methods.startHandler();
                        }
                        else{
                            global.sprint._component.methods.startHandler();
                        }
                    }
                    //FORCE LOGOUT
                    else if(data.esito == 999){
                        global.utils.blockPage();
                        setTimeout(() => {
                            global.utils.alert.standard(data.messaggio);
                        }, 500);
                        setTimeout(() => {
                            window.location.href = global.utils.BASE_API + "core/logout";
                        }, 3000);
                    }
                    if (_flgGestioneEsito == undefined || _flgGestioneEsito == 0){
                        global.utils.alert.warning(data.messaggio);
                    }
                    else{
                        _handler(data);
                    }
                }
            },
            error: function( jqXHR,  textStatus, errorThrown ){
                global.utils.alert.danger("Si è verificato un errore");
                console.error(jqXHR,textStatus,errorThrown);
                if (jqXHR.status == 0){
                   // global.utils.stopSocket();
                }
                if (_showBar == true ){
                    global.utils.unblockPage();
                }
            }
		});
    },

    uploadAjax: function(_api, _args, _handler, _showBar = true, _flgGestioneEsito = 0, _method = "POST") {
        if (_showBar) {
            global.utils.blockPage();
        }
        console.log('entro qui')
        const url = global.utils.BASE_API + _api;
        // Verifico se _args è già un FormData, altrimenti lo creo
        let formData = _args instanceof FormData ? _args : new FormData();
        if (!(_args instanceof FormData)) {
            for (const key in _args) {
                formData.append(key, _args[key]);
            }
        }
        // Aggiungo il SESSION_TOKEN
        formData.append("SESSION_TOKEN", global.utils.SESSION_TOKEN);
        fetch(url, {
            method: _method,
            body: formData, // FormData gestisce da solo il Content-Type multipart/form-data
        })
        .then(response => {
            /*if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();*/
            return response.text().then(text => {
                console.log("📄 Contenuto della risposta:", text);
        
                try {
                    // Proviamo a fare il parsing JSON
                    const jsonData = JSON.parse(text);
                    console.log("✅ Dati ricevuti dal server:", jsonData);
                    return jsonData;
                } catch (error) {
                    console.error("❌ La risposta non è un JSON valido!", error);
                    throw new Error("Il server ha restituito un formato non JSON: " + text);
                }
            });
            
        })
        .then(data => {
            if (_showBar) {
                global.utils.unblockPage();
            }
    
            if (data.esito === 0) {
                if (data['arrayCampi'] !== undefined && data['compressed'] !== undefined) {
                    data.data = global.utils.getArrayFromJSON(data.arrayCampi, data.data);
                }
                _handler(data);
            } else {
                if (data.esito === 401) {
                    if (global.utils.RELOAD_SESSIONE_SCADUTA === 1) {
                        global.sprint._component.methods.startHandler();
                    } else {
                        global.sprint._component.methods.startHandler();
                    }
                } else if (data.esito === 999) {
                    global.utils.blockPage();
                    setTimeout(() => {
                        global.utils.alert.standard(data.messaggio);
                    }, 500);
                    setTimeout(() => {
                        window.location.href = global.utils.BASE_API + "core/logout";
                    }, 3000);
                }
    
                /*if (_flgGestioneEsito === 0) {
                    global.utils.alert.warning(data.messaggio);
                }*/
    
                _handler(data);
            }
        })
        .catch(err => {
            if (_showBar) {
                global.utils.unblockPage();
            }
            global.utils.alert.danger("Si è verificato un errore di rete.");
            console.error("Errore di rete", err);
            _handler({ esito: -1, messaggio: "Errore di rete", error: err });
        });
    },


    /*
    uploadNew : function(_api,_args,_handler,_showBar = true,_flgGestioneEsito = 0,_method = null){
        _method = (_method == undefined || _method == null) ? "POST" : _method;
        if (_showBar == true ){
            global.utils.blockPage();
        }
        //console.log(_api);
        let formData;
        if(_args instanceof FormData){
            formData = _args
        }else{
            formData = new FormData();
            for (const key in _args){
                formData.append(key, _args[key])
            }
        }
        //console.log(formData)
        utils.ajax(_api, formData,function(data){

            if (_showBar == true ){
                global.utils.unblockPage();
            }    
            if (data.esito == 0){
                if (data['arrayCampi'] != undefined && data['compressed'] != undefined){
                    data.data = global.utils.getArrayFromJSON(data.arrayCampi,data.data);
                }
                _handler(data);
            }
            else{
                //SESSIONE UTENTE SCADUTA
                if (data.esito == 401){
                    if (global.utils.RELOAD_SESSIONE_SCADUTA == 1){
                        //global.utils.alert.standard("Sessione utente scaduta");
                        global.sprint._component.methods.startHandler();
                    }
                    else{
                        global.sprint._component.methods.startHandler();
                    }
                }
                //FORCE LOGOUT
                else if(data.esito == 999){
                    global.utils.blockPage();
                    setTimeout(() => {
                        global.utils.alert.standard(data.messaggio);
                    }, 500);
                    setTimeout(() => {
                        window.location.href = global.utils.BASE_API + "core/logout";
                    }, 3000);
                }
                if (_flgGestioneEsito == undefined || _flgGestioneEsito == 0){
                    global.utils.alert.warning(data.messaggio);
                }
                else{
                    _handler(data);
                }
            }
        }, _showBar, _flgGestioneEsito, _method);
    },
    
    uploadNew : function(_api,_args,_handler,_showBar = true,_flgGestioneEsito = 0,_method = null){
       
        if (_showBar == true ){
            global.utils.blockPage();
        }
        const url = global.utils.BASE_API +_api;
        let body = _args instanceof FormData ? _args : new FormData();
        if ( !(_args instanceof FormData)){
            for (const key in _args){
                body.append(key, _args[key])
            }
        }
        body.append("SESSION_TOKEN",global.utils.SESSION_TOKEN);

        fetch(url,{
            method: _method,
            body: body,
        })
        .then(response => response.json()) 
        .then(data => {
            if (_showBar == true ){
                global.utils.unblockPage();
            }
            if (data.esito == 0){
                if (data['arrayCampi'] != undefined && data['compressed'] != undefined){
                    data.data = global.utils.getArrayFromJSON(data.arrayCampi,data.data);
                }
                _handler(data);
            }
            else{
                //SESSIONE UTENTE SCADUTA
                if (data.esito == 401){                       
                    if (global.utils.RELOAD_SESSIONE_SCADUTA == 1){
                        //global.utils.alert.standard("Sessione utente scaduta");
                        global.sprint._component.methods.startHandler();
                    }
                    else{
                        global.sprint._component.methods.startHandler();
                    }
                }
                //FORCE LOGOUT
                else if(data.esito == 999){
                    global.utils.blockPage();
                    setTimeout(() => {
                        global.utils.alert.standard(data.messaggio);
                    }, 500);
                    setTimeout(() => {
                        window.location.href = global.utils.BASE_API + "core/logout";
                    }, 3000);
                }
                if (_flgGestioneEsito == undefined || _flgGestioneEsito == 0){
                    global.utils.alert.warning(data.messaggio);
                }
                else{
                    _handler(data);
                }
            }
        })
        .catch(err => {
            if (_showBar == true ){
                global.utils.unblockPage();
            }
            global.utils.alert.danger("Si è verificato un errore");
            console.error("Errore di rete" , err);   
            _handler({esito : -1, messaggio: "Errore di Rete", error: err})        
            
        });
        /*
        utils.ajax(_api, formData,function(data){

            if (_showBar == true ){
                global.utils.unblockPage();
            }    
            if (data.esito == 0){
                if (data['arrayCampi'] != undefined && data['compressed'] != undefined){
                    data.data = global.utils.getArrayFromJSON(data.arrayCampi,data.data);
                }
                _handler(data);
            }
            else{
                //SESSIONE UTENTE SCADUTA
                if (data.esito == 401){
                    if (global.utils.RELOAD_SESSIONE_SCADUTA == 1){
                        //global.utils.alert.standard("Sessione utente scaduta");
                        global.sprint._component.methods.startHandler();
                    }
                    else{
                        global.sprint._component.methods.startHandler();
                    }
                }
                //FORCE LOGOUT
                else if(data.esito == 999){
                    global.utils.blockPage();
                    setTimeout(() => {
                        global.utils.alert.standard(data.messaggio);
                    }, 500);
                    setTimeout(() => {
                        window.location.href = global.utils.BASE_API + "core/logout";
                    }, 3000);
                }
                if (_flgGestioneEsito == undefined || _flgGestioneEsito == 0){
                    global.utils.alert.warning(data.messaggio);
                }
                else{
                    _handler(data);
                }
            }
        }, _showBar, _flgGestioneEsito, _method);
        */
    /*
    },
    */

    downloadExcel: function(api, args, filename = "export.xlsx") {
        args.SESSION_TOKEN = global.utils.SESSION_TOKEN;
        const url = global.utils.BASE_API + api;
        
        fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(args)
          })
          .then(response => {
            if (!response.ok) {
              throw new Error('Errore nella risposta');
            }
            return response.blob();
          })
          .then(blob => {
            console.log("Dimensione blob:", blob.size);
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = blobUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(blobUrl);
          })
          .catch(error => {
            console.error('Errore durante il download del file Excel:', error);
            global.utils.alert.danger("Errore nel download del file Excel.");
          });
    },

    esportaTabella: function(options) {
        // options = {
        //   tipo:          'tutti' | 'selezionati' | 'pagina'
        //   arrayCompleto: []              // array pieno del modulo
        //   arrayPagina:   []              // paginatedList.arr (pagina corrente)
        //   idField:       'ID_NOTA_SPESA' // campo PK
        //   modulo:        'noteSpese'     // chiave di dispatch backend
        //   formato:       1 | 2           // 1 = PDF, 2 = Excel (default 2)
        //   nomeFile:      'note_spese'    // nome base del file (senza estensione)
        // }
        var formato = options.formato || 2;

        var sourceArray;
        if (options.tipo == 'selezionati') {
            sourceArray = global.utils.array.select(options.arrayCompleto, 'SELEZIONATO', 1);
            if (sourceArray.length == 0) {
                global.utils.alert.warning('Nessun elemento selezionato.');
                return;
            }
        } else if (options.tipo == 'pagina') {
            sourceArray = options.arrayPagina;
        } else {
            sourceArray = options.arrayCompleto;
        }

        var ids = sourceArray.map(function(item) { return item[options.idField]; });

        // Mappa modulo → ID_REPORT (lato client, come fa 1005_BudgetProgetto.php)
        var moduliMap = { noteSpese: 2001, aziende: 2002, utenti: 2003, progetti: 2004, vociPreferite: 2005 };
        var idReport = moduliMap[options.modulo];
        if (!idReport) {
            global.utils.alert.warning('Modulo export non riconosciuto: ' + options.modulo);
            return;
        }

        // Apertura diretta via GET con IDS nella URL — nessuna sessione necessaria
        window.open(
            global.utils.BASE_API +
            'theb/report?ID_REPORT=' + idReport +
            '&FORMATO=' + formato +
            '&IDS=' + ids.join(',') +
            global.utils.getSessionToken()
        );
    },

    download : function(_api,_args,_handler,_showBar = true,_flgGestioneEsito = 0,_method = null){
        _method = (_method == undefined || _method == null) ? "POST" : _method;
        if (_showBar == true ){
            global.utils.blockPage();
        }
        _args.SESSION_TOKEN = global.utils.SESSION_TOKEN;
        //_args.FROM = 'deskalo';
        global.ajax({
			type: _method,
			data: _args,
			url: global.utils.BASE_API + _api,
			cache: false,
            //contentType: 'application/octet-stream',  
			//dataType: 'json',
			success: function (data) {
                _handler(data);
            },
            error: function( jqXHR,  textStatus, errorThrown ){
                global.utils.alert.danger("Si è verificato un errore");
                console.error(jqXHR,textStatus,errorThrown);
                if (jqXHR.status == 0){
                   // global.utils.stopSocket();
                }
                if (_showBar == true ){
                    global.utils.unblockPage();
                }
            }
		});
    },
    
    setCookie : function(cname, cvalue, exdays) {
        var expires = '';
        if (exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            expires = "expires=" + d.toUTCString() + ";";
        }
        document.cookie = cname + "=" + cvalue + ";" + expires + "path=/";
    },

    deleteCookie : function(cname){
        document.cookie = cname + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
    },

    getCookie : function(cname) {
        //("cookie");
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },

    report : {
        token:function(args){
            global.utils.ajax('/core/report/basic/token',args, (response) => {
                if (response.esito == 0){
                    window.open(global.utils.BASE_API + '/core/report/basic?ID_REPORT=0&FORMATO='+args.formato+'&token='+response.messaggio );
                }
            });
        },
    },

    getArrayFromJSON : function(arrayCampi,arrayValori){
        var arrayDati = new Array();
        for (var i = 0 ; i<arrayValori.length ; i++){
            var item = new Object();
            for (var j = 0 ; j < arrayCampi.length ; j++){
                item[arrayCampi[j]] = arrayValori[i][j];
            }
            arrayDati.push(item);
        }
        return arrayDati;
    },

    diagnosi : function(item){
        //console.log(item);
    },

    setHeader : function(_icon,_title){
        if (typeof global.sprint !== "undefined"){
            global.sprint._component.icon = _icon;
            global.sprint._component.title = _title;            
        }
        else{
            setTimeout(() => {
                global.utils.setHeader(_icon,_title);
            }, 500);
        }
    },

    alert : {
        show:function(_tipo,messaggio,icona = "",titolo = "Attenzione",delay = 5000){
            // global.utils.notify(_tipo, titolo, messaggio,delay,icona);
            new Notify({
                status: _tipo,
                title: titolo,
                text: messaggio,
                effect: 'slide',
                speed: 500,
                customClass: null,
                customIcon: null,
                showIcon: true,
                showCloseButton: true,
                autoclose: true,
                autotimeout: 3000,
                gap: 20,
                distance: 20,
                type: 'filled',
                position: 'right top'
              });
        },
        success:function(messaggio,titolo = "Attenzione", delay = 2500,icona = "",){
            global.utils.alert.show("success",messaggio,icona,titolo,delay);
        },
        warning:function(messaggio,titolo = "Attenzione", icona = "",delay = 5000){
            global.utils.alert.show("warning",messaggio,icona,titolo,delay);
        },
        info:function(messaggio,titolo = "Attenzione", icona = "",delay = 5000){
            global.utils.alert.show("info",messaggio,icona,titolo,delay);
        },
        danger:function(messaggio,titolo = "Attenzione", icona = "",delay = 5000){
            global.utils.alert.show("error",messaggio,icona,titolo,delay);
        },
        primary:function(messaggio,titolo = "Attenzione", icona = "",delay = 5000){
            global.utils.alert.show("alert",messaggio,icona,titolo,delay);
        },
        confirm:function(messaggio,okHandler,root,titolo = "Conferma scelta",koHandler = null,btnOk = "OK",btnKo = "Annulla",icona="fa-exclamation-triangle"){
            var alertConfirm = {
                MESSAGE : messaggio,
                TITLE : titolo,
                OKHandler : () => {
                    global.filters.closePopUp('popUpConfirm');
                    okHandler()
                },
                KOHandler : () => {
                    global.filters.closePopUp('popUpConfirm');
                    if(koHandler != null){
                        koHandler()
                    }
                },
                OK : btnOk,
                KO : btnKo,
                ICON : icona
            }
            //console.log(root);
            root.confirm(alertConfirm);
        },
        standard:function(messaggio,okHandler = null,titolo = "Attenzione",btnOk = "OK",icona="fal fa-info-circle"){
            global.sprint.alertStd = {
                MESSAGE : messaggio,
                TITLE : titolo,
                OKHandler : () => {
                    global.filters.closePopUp('popUpAlertStandard');
                    //var modal = global.$('#popUpAlertStandard');
                    //modal.modal('hide');
                    if (okHandler != null){
                        okHandler();
                    }
                },
                OK : btnOk,
                ICON : icona
            }
            global.filters.openPopUp('popUpAlertStandard');
            //var modal = global.$('#popUpAlertStandard');
            //modal.modal('show');
        }              
    },

    clone : function(obj){
        if (obj == undefined)
            return {};
        var s = JSON.stringify(obj);
        var newObj = JSON.parse(s);
        return newObj;
    },

    _loadingCount : 0,

    blockPage : function() {
        this._loadingCount++;
        var loading = document.getElementById('loading');
        if (loading != null)
            loading.classList.add('is-active');
    },

    unblockPage : function() {
        this._loadingCount = Math.max(0, this._loadingCount - 1);
        if (this._loadingCount == 0) {
            var loading = document.getElementById('loading');
            if (loading != null)
                loading.classList.remove('is-active');
        }
    },
    addClass : function(element,className){
        var element = document.getElementById(element);
        if (element != null)
            element.classList.add(className)
    },
    removeClass : function(element,className){
        var element = document.getElementById('loading');
        if (element != null)
            element.classList.remove(className);
    },

    pagination : {
        paginate:function(source,search){
            var page = parseInt(search.PAGINATION.PAGE_NUMBER) - 1;
            var itemsPerPage = parseInt(search.PAGINATION.PAGE_SIZE) || 25;
            var index = 0;
            var start = page * itemsPerPage;
            var end = start + itemsPerPage ;
            return source.filter( () => {
                if (index >= start && index < end){
                    index++;
                    return true;
                }
                index++;
                return false;
            })
        }
    },

    arrayGiorniSettimana : new Array(
        {ID_GIORNO:2,DESCRIZIONE:"LUNEDI",DESC_2:"LU",DESC_3:"LUN"},
        {ID_GIORNO:3,DESCRIZIONE:"MARTEDI",DESC_2:"MA",DESC_3:"MAR"},
        {ID_GIORNO:4,DESCRIZIONE:"MERCOLEDI",DESC_2:"ME",DESC_3:"MER"},
        {ID_GIORNO:5,DESCRIZIONE:"GIOVEDI",DESC_2:"GI",DESC_3:"GIO"},
        {ID_GIORNO:6,DESCRIZIONE:"VENERDI",DESC_2:"VE",DESC_3:"VEN"},
        {ID_GIORNO:7,DESCRIZIONE:"SABATO",DESC_2:"SA",DESC_3:"SAB"},
        {ID_GIORNO:1,DESCRIZIONE:"DOMENICA",DESC_2:"DO",DESC_3:"DOM"},
    ),

    getGiornoSettimana(idGiorno){
        return global.utils.array.select(global.utils.arrayGiorniSettimana,"ID_GIORNO",idGiorno,1)[0];
    },

    arrayMesi : new Array(
        {ID_MESE:1,DESCRIZIONE:"GENNAIO",DESC_3:"GEN"},
        {ID_MESE:2,DESCRIZIONE:"FEBBRAIO",DESC_3:"FEB"},
        {ID_MESE:3,DESCRIZIONE:"MARZO",DESC_3:"MAR"},
        {ID_MESE:4,DESCRIZIONE:"APRILE",DESC_3:"APR"},
        {ID_MESE:5,DESCRIZIONE:"MAGGIO",DESC_3:"MAG"},
        {ID_MESE:6,DESCRIZIONE:"GIUGNO",DESC_3:"GIU"},
        {ID_MESE:7,DESCRIZIONE:"LUGLIO",DESC_3:"LUG"},
        {ID_MESE:8,DESCRIZIONE:"AGOSTO",DESC_3:"AGO"},
        {ID_MESE:9,DESCRIZIONE:"SETTEMBRE",DESC_3:"SET"},
        {ID_MESE:10,DESCRIZIONE:"OTTOBRE",DESC_3:"OTT"},
        {ID_MESE:11,DESCRIZIONE:"NOVEMBRE",DESC_3:"NOV"},
        {ID_MESE:12,DESCRIZIONE:"DICEMBRE",DESC_3:"DIC"}
    ),

    arrayContinenti : new Array(
        {ID_CONTINENTE:1,DESCRIZIONE:"Asia"},
        {ID_CONTINENTE:2,DESCRIZIONE:"Messico e Caraibi"},
        {ID_CONTINENTE:3,DESCRIZIONE:"Europa"},
        {ID_CONTINENTE:4,DESCRIZIONE:"Africa"},
        {ID_CONTINENTE:5,DESCRIZIONE:"Oceano Indiano"},
        {ID_CONTINENTE:6,DESCRIZIONE:"Medio Oriente"},
        {ID_CONTINENTE:7,DESCRIZIONE:"Nord America"},
        {ID_CONTINENTE:8,DESCRIZIONE:"Pacifico"},
        {ID_CONTINENTE:9,DESCRIZIONE:"Sud America"},
        {ID_CONTINENTE:10,DESCRIZIONE:"Antartide"}
    ),

    getMese(idMese){
        return global.utils.array.select(global.utils.arrayMesi,"ID_MESE",idMese,1)[0];
    },

    getOrari(oraInizio,oraFine){
        var arrayOrari = new Array();
        for (var i = oraInizio ; i < oraFine ; i++){
            for (var j = 0 ; j < 60 ; j = j+5){
                var ora = i < 10 ? '0'+i : i;
                var minuto = j < 10 ? '0'+j : j;
                arrayOrari.push(ora+":"+minuto+":00");
            }
        }
        return arrayOrari;
    },

    getImportoScontato : function(importo,sconto){
        return Math.round((importo - (importo / 100 * sconto))*100) / 100;  
    },

    getSessionToken : function(){
        if (utils.BASE_API.search("localhost") > -1 || utils.BASE_API.search("192")){
            return "&SESSION_TOKEN="+utils.SESSION_TOKEN;
        }
        return "";
    },

    bonificaNumber : function(n){
        //console.log("bonifica");
        if (!isNaN(n)){
            return n;
        }
        else{
            s = n.toString();
            s = s.replace(".","");
            s = s.replace(",",".");
            if (!isNaN(s)){
                return parseFloat(s);
            }
            return NaN;
        }
    },

    formatNumber : function(num){   
        num = new Intl.NumberFormat('de-DE',{
            style:'decimal',
            minimumFractionDigits: 2
        }).format(num);
        return num;
    },

    formatNumberInt : function(num){   
        num = new Intl.NumberFormat('de-DE',{
            style:'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(num);
        return num;
    },

    getRandomInt : function(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    getRandomString(length) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    },

    // LOADER
    createLoader : function(){
        //LOADER
        var t = document.createElement('div')
        t.innerHTML = `<div id="loading" class="loader loader-default">
            <div class="loader-default-sub"><div style="margin-top:32px;margin-left:80px;font-size:22px">Attendere prego</div></div>
        </div>`;
        document.body.appendChild(t);
        //global.document.body.insertAdjacentElement("beforeend", t);
        //global.$('body').append(`<div id="loading" class="loader loader-default">
        //    <div class="loader-default-sub"><div style="margin-top:32px;margin-left:80px;font-size:22px">Attendere prego</div></div>
        //</div>`);
    },

    getDateFromString : function(d){
        if (d == undefined || d == "" || d == null){
            return null;
        }
         //DATA INGLESE
        if (d.toString().indexOf("/") == -1){
            return new Date(d);
        }
        //DATA ITALIANA
        else{
            spl = d.toString().split("/");
            //VERIFICO LA PRESENZA DI UN TIME
            if (spl[2].toString().indexOf(" ") > -1){
                const anno = spl[2].toString().substring(0,4);
                const orario = spl[2].toString().substring(4);
                var s = anno + "/" + spl[1] + "/" + spl[0] + orario.substring(2);
                var d = new Date(s);
                return d;
            }
            var s = spl[2] +"/"+ spl[1] +"/"+ spl[0];
            return new Date(s);
        }
    },

    filter : function(source,search){
        var keys = Object.getOwnPropertyNames(search);
        var arr = source.filter(item => {
            for (var i = 0 ; i < keys.length ; i++){
                var prop = keys[i];
                if (item[prop] == undefined && search[prop]['TYPE'] != 'COMBO_IN_ARRAY' && search[prop]['TYPE'] != 'TEXT_IN_ARRAY'){
                    esito = true;
                    continue;
                }
                if (prop != "PAGINATION"){
                    var esito = true;
                    switch (search[prop]['TYPE']){
                        case 'TEXT':
                            esito = item[prop].toString().toLowerCase().includes(search[prop].VALUE.toLowerCase());
                            break;
                        case 'INT_RANGE':
                            if (search[prop].VALUE_FROM == "" && search[prop].VALUE_TO == ""){
                                esito = true;
                                break;
                            }
                            if (item[prop] >= search[prop].VALUE_FROM && (item[prop] <= search[prop].VALUE_TO || search[prop].VALUE_TO == "")){
                                esito = true;
                                break;
                            }
                            if (item[prop] <= search[prop].VALUE_TO && (item[prop] >= search[prop].VALUE_FROM || search[prop].VALUE_FROM == "")){
                                esito = true;
                                break;
                            }
                            esito = false;
                            break;
                        case 'COMBO':
                            if (search[prop].VALUE == "" || search[prop].VALUE == null){
                                esito = true;
                                break;
                            }
                            if (search[prop].VALUE.toString().search(",") != -1){
                                arr = search[prop].VALUE.split(",");
                                esito = arr.indexOf(item[prop]) > -1 ? true : false;
                                break;
                            }
                            else{
                                esito = item[prop] == search[prop].VALUE;
                                break;                                
                            }
                        case 'COMBO_IN_ARRAY':
                            if (search[prop].VALUE === ""){
                                esito = true;
                                break;
                            }
                            var proprietaArray = 'ARRAY';
                            if (search[prop].hasOwnProperty("CUSTOM_ARRAY")){
                                proprietaArray = 'CUSTOM_ARRAY';
                            }
                            esito = global.utils.array.select(item[search[prop][proprietaArray]],prop,search[prop].VALUE,1).length == 1 ? true : false;
                            break;
                        case 'TEXT_IN_ARRAY':
                            if (search[prop].VALUE === ""){
                                esito = true;
                                break;
                            }
                            var proprietaArray = 'ARRAY';
                            if (search[prop].hasOwnProperty("CUSTOM_ARRAY")){
                                proprietaArray = 'CUSTOM_ARRAY';
                            }
                            esito = false;
                            for (var k = 0 ; k < item[search[prop][proprietaArray]].length ; k++) {
                                const check = item[search[prop][proprietaArray]][k][prop].toString().toLowerCase().includes(search[prop].VALUE.toLowerCase());
                                if (check == true){
                                    esito = true;
                                    break;
                                }
                            }
                            break;

                        case 'DATE':
                            if (search[prop].VALUE == ""){
                                esito = true;
                                break;
                            }
                            var dProp = global.utils.getDateFromString(item[prop]);
                            if (dProp == null){
                                esito = false;
                                break;
                            }
                            var dataFiltro = global.utils.getDateFromString(search[prop].VALUE);
                            esito = dProp.getTime() == dataFiltro.getTime();
                            break;

                        case 'DATE_TIME':
                            if (search[prop].VALUE == "" || search[prop].VALUE == null){
                                esito = true;
                                break;
                            }
                            esito = item[prop].toString().includes(search[prop].VALUE);
                            break;

                        case 'DATE_RANGE':
                            var dPropr =  global.utils.getDateFromString(item[prop]  );
                            if (dPropr == null){
                                esito = true;
                                break;
                            }
                            var dataFiltroFrom = global.utils.getDateFromString(search[prop].VALUE_FROM );
                            var dataFiltroTo = global.utils.getDateFromString(search[prop].VALUE_TO );
                            if (dataFiltroFrom == null && dataFiltroTo == null){
                                esito = true;
                                break;
                            }
                            else if (dataFiltroFrom != null && dataFiltroTo != null){
                                esito = (dPropr.getTime() >= dataFiltroFrom.getTime() && dPropr.getTime() <= dataFiltroTo.getTime());
                                break;
                            }
                            else if (dataFiltroFrom != null && dataFiltroTo == null){
                                esito = (dPropr.getTime() >= dataFiltroFrom.getTime());
                            }
                            else{
                                esito = (dPropr.getTime() <= dataFiltroTo.getTime());
                            }
                            break;
                    }
                    if (esito == false){
                        //console.log(search[prop]);
                        return false;
                    }
                }
            }
            return true;
        })
        search.PAGINATION.LENGTH = Math.ceil(arr.length/search.PAGINATION.PAGE_SIZE);
        if (search.PAGINATION.LENGTH < search.PAGINATION.PAGE_NUMBER){
            search.PAGINATION.PAGE_NUMBER = 1;
        }
        return arr;
    },

    initTooltips: function (selector = '[data-bs-toggle="tooltip"]') {
        var tooltipTriggerList = [].slice.call(document.querySelectorAll(selector));
        tooltipTriggerList.forEach(function (tooltipTriggerEl) {
            if (!bootstrap.Tooltip.getInstance(tooltipTriggerEl)) {
                new bootstrap.Tooltip(tooltipTriggerEl);
            }
        });
    },

    inGrid : function(_array,_search, ordinamento = null){
        // **<<< INIZIO CORREZIONE >>>**
        // Controllo se _array è nullo, undefined o non è un array.
        // In caso negativo, restituisco immediatamente un risultato vuoto.
        if (!_array || !Array.isArray(_array)) {
            return {
                arr: [],
                count: 0
            };
        }
        // **<<< FINE CORREZIONE >>>**
        var filtrato = global.utils.filter(_array,_search);
        if (ordinamento != null){
            if (!(ordinamento.indexOf(",") > -1)){
                filtrato = global.utils.array.ordinaArray(filtrato,ordinamento.substring(1));
                if (ordinamento.charAt(0) == "-"){
                    filtrato = filtrato.reverse();
                }
            }
            else{
                var arr = ordinamento.split(",");
                var item = {};
                for (var i = 0 ; i < arr.length ; i++){
                    var senso = (arr[i].charAt(0) == "-") ? "desc" : "asc";
                    var prop = arr[i].substring(1);
                    item[prop] = senso;
                }
                filtrato = global.utils.array.multiSort(filtrato, item);
            }
        }
        setTimeout(() => {
            global.utils.initTooltips();
        }, 500);
        return {
            arr: global.utils.pagination.paginate(filtrato ,_search),
            count: filtrato.length
        }
    },

    inGridNested: function (_array, _search, ordinamento = null, nestedKey = null){
        var filtrato = [];
        if (_search && nestedKey) {
            const searchValue = (_search.USERNAME?.VALUE || "").toLowerCase();
            for (var i = 0; i < _array.length; i++) {
                var item = _array[i];
                if (item[nestedKey] && Array.isArray(item[nestedKey])) {
                    for (var j = 0; j < item[nestedKey].length; j++) {
                        var subItem = item[nestedKey][j];
    
                        for (var key in subItem) {
                            if (String(subItem[key]).toLowerCase().indexOf(searchValue) !== -1) {
                                filtrato.push(item);
                                break;
                            }
                        }
                        if (filtrato.includes(item)) {
                            break;
                        }
                    }
                }
            }
        } else if (_search) {
            const searchValue = (_search.USERNAME?.VALUE || "").toLowerCase();
    
            for (var i = 0; i < _array.length; i++) {
                var item = _array[i];
    
                for (var key in item) {
                    if (String(item[key]).toLowerCase().indexOf(searchValue) !== -1) {
                        filtrato.push(item);
                        break;
                    }
                }
            }
        } else {
            filtrato = _array;
        }
        if (ordinamento != null) {
            if (!(ordinamento.indexOf(",") > -1)) {
                filtrato = global.utils.array.ordinaArray(filtrato, ordinamento.substring(1));
                if (ordinamento.charAt(0) == "-") {
                    filtrato = filtrato.reverse();
                }
            } else {
                var arr = ordinamento.split(",");
                var item = {};
                for (var i = 0; i < arr.length; i++) {
                    var senso = (arr[i].charAt(0) == "-") ? "desc" : "asc";
                    var prop = arr[i].substring(1);
                    item[prop] = senso;
                }
                filtrato = global.utils.array.multiSort(filtrato, item);
            }
        }
        _search.PAGINATION.LENGTH = Math.ceil(filtrato.length / _search.PAGINATION.PAGE_SIZE);
        if (_search.PAGINATION.LENGTH < _search.PAGINATION.PAGE_NUMBER) {
            _search.PAGINATION.PAGE_NUMBER = 1;
        }
        return {
            arr: global.utils.pagination.paginate(filtrato, _search),
            count: filtrato.length
        };
    },

    inGridRecursive: function(_array, _search, ordinamento = null) {
        function filterRecursive(items) {
            return items.reduce((filtered, item) => {
                let itemMatches = true;
                let newItem = {...item};
                for (let key in _search) {
                    if (key !== 'PAGINATION' && _search[key].VALUE !== '') {
                        if (item[key] !== undefined) {
                            let searchValue = String(_search[key].VALUE).toLowerCase();
                            let itemValue = String(item[key]).toLowerCase();
                            
                            if (!itemValue.includes(searchValue)) {
                                itemMatches = false;
                            }
                        }
                    }
                }
                if (item.children && item.children.length > 0) {
                    newItem.children = filterRecursive(item.children);
                    if (newItem.children.length > 0) {
                        itemMatches = true;
                    }
                }
                
                if (itemMatches) {
                    filtered.push(newItem);
                }
                return filtered;
            }, []);
        }
        
        let filtrato = filterRecursive(_array);
        if (ordinamento != null) {
            if (!(ordinamento.indexOf(",") > -1)) {
                filtrato = global.utils.array.ordinaArray(filtrato, ordinamento.substring(1));
                if (ordinamento.charAt(0) == "-") {
                    filtrato = filtrato.reverse();
                }
            } else {
                let arr = ordinamento.split(",");
                let item = {};
                for (let i = 0; i < arr.length; i++) {
                    let senso = (arr[i].charAt(0) == "-") ? "desc" : "asc";
                    let prop = arr[i].substring(1);
                    item[prop] = senso;
                }
                filtrato = global.utils.array.multiSort(filtrato, item);
            }
        }
        
        return {
            arr: global.utils.pagination.paginate(filtrato, _search),
            count: filtrato.length
        };
    },

    inGridRicorsiva: function(_array, _search, ordinamento, voceKey) {
        voceKey = voceKey || 'VOCI';
        var keys = Object.getOwnPropertyNames(_search);
        var activeFilters = [];
        for (var k = 0; k < keys.length; k++) {
            if (keys[k] !== 'PAGINATION' && _search[keys[k]].VALUE !== '') {
                activeFilters.push(keys[k]);
            }
        }

        function matchField(item, prop) {
            if (item[prop] === undefined || item[prop] === null) return null;
            var val = item[prop].toString();
            var searchVal = _search[prop].VALUE.toString();
            switch (_search[prop].TYPE) {
                case 'TEXT': return val.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0;
                case 'COMBO': return val === searchVal;
                case 'NUMBER': return item[prop] == _search[prop].VALUE;
                case 'DATE': return item[prop] == _search[prop].VALUE;
                default: return null;
            }
        }

        function filterNode(node) {
            var voceFilters = [];
            for (var i = 0; i < activeFilters.length; i++) {
                var prop = activeFilters[i];
                var res = matchField(node, prop);
                if (res === null) {
                    voceFilters.push(prop);
                } else if (!res) {
                    return null;
                }
            }

            var copy = Object.assign({}, node);

            var filteredSub = [];
            if (node.SOTTO_ATTIVITA && node.SOTTO_ATTIVITA.length > 0) {
                for (var s = 0; s < node.SOTTO_ATTIVITA.length; s++) {
                    var sub = filterNode(node.SOTTO_ATTIVITA[s]);
                    if (sub !== null) filteredSub.push(sub);
                }
                copy.SOTTO_ATTIVITA = filteredSub;
            }

            if (voceFilters.length > 0) {
                var voci = node[voceKey] || [];
                var filteredVoci = voci.filter(function(voce) {
                    for (var i = 0; i < voceFilters.length; i++) {
                        var r = matchField(voce, voceFilters[i]);
                        if (r !== null && !r) return false;
                    }
                    return true;
                });
                copy[voceKey] = filteredVoci;
                if (filteredVoci.length === 0 && filteredSub.length === 0) return null;
            }

            return copy;
        }

        var filtrato = [];
        for (var i = 0; i < _array.length; i++) {
            var result = filterNode(_array[i]);
            if (result !== null) filtrato.push(result);
        }

        if (ordinamento) {
            if (ordinamento.indexOf(',') < 0) {
                filtrato = global.utils.array.ordinaArray(filtrato, ordinamento.substring(1));
                if (ordinamento.charAt(0) === '-') filtrato = filtrato.reverse();
            } else {
                var arr = ordinamento.split(',');
                var sortObj = {};
                for (var i = 0; i < arr.length; i++) {
                    sortObj[arr[i].substring(1)] = (arr[i].charAt(0) === '-') ? 'desc' : 'asc';
                }
                filtrato = global.utils.array.multiSort(filtrato, sortObj);
            }
        }

        _search.PAGINATION.LENGTH = Math.ceil(filtrato.length / _search.PAGINATION.PAGE_SIZE);
        if (_search.PAGINATION.LENGTH < _search.PAGINATION.PAGE_NUMBER) {
            _search.PAGINATION.PAGE_NUMBER = 1;
        }

        return {
            arr: global.utils.pagination.paginate(filtrato, _search),
            count: filtrato.length
        };
    },

    
    inGrid2Levels: function(_array, _search, ordinamento = null, nestedKey = null){
        var filtrato = [];
        var keys = Object.getOwnPropertyNames(_search);

        var activeFilters = [];
        for (var k = 0; k < keys.length; k++){
            var prop = keys[k];
            if (prop != "PAGINATION" && _search[prop].VALUE != ""){
                activeFilters.push(prop);
            }
        }
        if (activeFilters.length == 0){
            filtrato = _array;
        }
        else{
            for (var i = 0; i < _array.length; i++){
                var item = _array[i];
                var itemMatchCount = 0;
                var itemFilterCount = 0;
                var vociFiltered = [];

                for (var k = 0; k < activeFilters.length; k++){
                    var prop = activeFilters[k];

                    if (item[prop] != undefined){
                        itemFilterCount++;
                        var esito = true;
                        switch (_search[prop]['TYPE']){
                            case 'TEXT':
                                esito = item[prop].toString().toLowerCase().includes(_search[prop].VALUE.toLowerCase());
                                break;
                            case 'COMBO':
                                esito = (item[prop].toString() == _search[prop].VALUE);
                                break;
                            case 'NUMBER':
                                esito = (item[prop] == _search[prop].VALUE);
                                break;
                            case 'DATE':
                                esito = (item[prop] == _search[prop].VALUE);
                                break;
                        }
                        if (esito){
                            itemMatchCount++;
                        }
                    }
                }

                if (nestedKey && item[nestedKey] && Array.isArray(item[nestedKey])){
                    for (var j = 0; j < item[nestedKey].length; j++){
                        var child = item[nestedKey][j];
                        var childMatchCount = 0;
                        var childFilterCount = 0;

                        for (var k = 0; k < activeFilters.length; k++){
                            var prop = activeFilters[k];

                            if (child[prop] != undefined){
                                childFilterCount++;
                                var esito = true;
                                switch (_search[prop]['TYPE']){
                                    case 'TEXT':
                                        esito = child[prop].toString().toLowerCase().includes(_search[prop].VALUE.toLowerCase());
                                        break;
                                    case 'COMBO':
                                        esito = (child[prop].toString() == _search[prop].VALUE.toString());
                                        break;
                                    case 'NUMBER':
                                        esito = (child[prop] == _search[prop].VALUE);
                                        break;
                                    case 'DATE':
                                        esito = (child[prop] == _search[prop].VALUE);
                                        break;
                                }
                                if (esito){
                                    childMatchCount++;
                                }
                            }
                        }


                        if (childFilterCount == 0 || childMatchCount == childFilterCount){
                            vociFiltered.push(child);
                        }
                    }
                }


                var itemMatchesAll = (itemFilterCount == 0 || itemMatchCount == itemFilterCount);

                if (itemMatchesAll){

                    var itemClone = Object.assign({}, item);
                    itemClone[nestedKey] = vociFiltered;
                    filtrato.push(itemClone);
                }

                else if (itemMatchesAll && itemFilterCount > 0 && (!nestedKey || !item[nestedKey])){
                    filtrato.push(item);
                }
            }
        }

        if (ordinamento != null){
            if (!(ordinamento.indexOf(",") > -1)){
                filtrato = global.utils.array.ordinaArray(filtrato,ordinamento.substring(1));
                if (ordinamento.charAt(0) == "-"){
                    filtrato = filtrato.reverse();
                }
            }
            else{
                var arr = ordinamento.split(",");
                var item = {};
                for (var i = 0 ; i < arr.length ; i++){
                    var senso = (arr[i].charAt(0) == "-") ? "desc" : "asc";
                    var prop = arr[i].substring(1);
                    item[prop] = senso;
                }
                filtrato = global.utils.array.multiSort(filtrato, item);
            }
        }

        setTimeout(() => {
            global.utils.initTooltips();
        }, 500);

        return {
            arr: global.utils.pagination.paginate(filtrato, _search),
            count: filtrato.length
        }
    },

    openFileOnChrome(allegato) {
        if (!allegato || !allegato.contenuto) {
            console.error("Nessun file disponibile");
            return;
        }
        // Decodifica il contenuto in Base64
        const byteCharacters = atob(allegato.contenuto);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        // Determina il tipo di file in base all'estensione
        const fileExtension = allegato.nome.split('.').pop().toLowerCase();
        let mimeType = "application/octet-stream"; // Default

        if (["pdf"].includes(fileExtension)) {
            mimeType = "application/pdf";
        } else if (["jpg", "jpeg", "png", "gif", "webp"].includes(fileExtension)) {
            mimeType = "image/" + fileExtension;
        } else if (["doc", "docx"].includes(fileExtension)) {
            mimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        } else if (["xls", "xlsx"].includes(fileExtension)) {
            mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        } else if (["txt"].includes(fileExtension)) {
            mimeType = "text/plain";
        }

        // Crea il file Blob e l'URL per aprirlo
        const blob = new Blob([byteArray], { type: mimeType });
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
    },

    arrayForCombo : function(array,campo_id,campo_descrizione){
        var arr = new Array();
        for (var i = 0 ; i < array.length ; i++){
            var item = {ID:parseInt(array[i][campo_id]),DESCRIZIONE:array[i][campo_descrizione]};
            arr.push(item);
        }
        return arr;
    },

    resizeContent : function(){
        return;
    //    console.info("resize");
        var altezza = 415;
        var h = window.innerHeight;
        //var h = global.$( window ).height();
   //     console.log("ALTEZZA: " + h);
        var deltaContenitori = 162;
        /*
        if (mostraBreadcumb == 0){
            deltaContenitori += 30;
        }*/
        var altezzaAggiunta = 0;
        if (global.document.querySelector('.delta') != null && global.document.querySelector('.delta').length > 0){
            altezzaAggiunta = global.document.querySelector('.delta').data("delta");
            //alert(altezzaAggiunta);
        }
        /*
        if (global.$('.delta').length > 0){
            altezzaAggiunta = global.$('.delta').data("delta");
            //alert(altezzaAggiunta);
        }
        */
        global.document.querySelector('html').style.height = h + "px";
        global.document.body.style.height = h + "px";
        global.document.getElementById('app').style.height = h + "px";
       // global.document.getElementById('wrapper').style.height = h + "px";    
        /*   
        global.$('html').css("height",h + "px");
        global.$('body').css("height",h + "px");
        global.$('#app').css("height",h + "px");
        global.$('#wrapper').css("height",h + "px");
        */
        //mostraBreadcumb
        deltaContenitori = deltaContenitori+altezzaAggiunta;
        if (global.document.querySelector('.table-cms') == null){
            global.document.querySelector('html').style["overflow-y"] = "auto";
            //global.document.querySelector('#content-wrapper').style["overflow-y"] = "auto";
            return;
        }
        /*
        if (global.$('.isprint-grid').length == 0){
            global.$('html').css("overflow-y","auto");
            global.$('#content-wrapper').css("overflow-y","auto");
            return;
        }
        */
        else{
            var ua = navigator.userAgent;
            var isMobile = false;
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua))
                isMobile = true;
            else
                isMobile = false;
            if (isMobile == false){
                //global.document.querySelector('#content-wrapper').css("overflow-y","hidden");
                //global.$('#content-wrapper').css("overflow-y","hidden");
            }
        }
        global.document.querySelector('html').style["overflow-y"] = "hidden";
      //
      console.log(h-(altezza-deltaContenitori));
        global.document.querySelector('.table-cms-wrapper').style.height = (h-(altezza-deltaContenitori))+"px";
        //global.document.querySelector('#kt_content').style.height(h-(altezza-deltaContenitori - 3 ));
        //global.document.querySelector('#kt_vue_content').style.height(h-(altezza-deltaContenitori - 3 ));
        global.document.querySelector('.table-cms').style.height = (h-(altezza - 20 + global.utils.deltaGriglia))+"px";
        //global.document.querySelector('.isprint-grid-tbody').style.height(h-(altezza + 6 + global.utils.deltaGriglia));
        
        /*
        global.$('html').css("overflow-y","hidden");
        global.$('#kt_content_parent').height(h-(altezza-deltaContenitori));
        global.$('#kt_content').height(h-(altezza-deltaContenitori - 3 ));
        global.$('#kt_vue_content').height(h-(altezza-deltaContenitori - 3 ));
        global.$('.isprint-grid').height(h-(altezza - 20 + global.utils.deltaGriglia));
        global.$('.isprint-grid-tbody').height(h-(altezza + 6 + global.utils.deltaGriglia));
        */
    },

    nuovoElemento : function(_element,_object,_popup){
        _element = _object;
        /*
        var modal = global.$('#' + _popup);
        modal.modal('show');*/
        global.filters.openPopUp(_popup);
        return _element;
    },

    modificaElemento : function(_element,_object,_popup){
        _element = global.utils.clone(_object);
        global.filters.openPopUp(_popup);
        /*var modal = global.$('#' + _popup);
        modal.modal('show');*/
        return _element;
    },

    salvaElemento : function(api,_object,_chiave,_popup,_handler = null){
        var method = _object[_chiave] == 0 ? 'insert' : 'update';
        global.utils.ajax(api + method,_object, (response) => {
            if (_handler != null){
                _handler(response);
            }
            else{
                if (response.esito == 0){
                    /*
                    var modal = global.$('#'+_popup);
                    modal.modal('hide');*/
                    global.filters.closePopUp(_popup);
                    global.utils.alert.success(response.messaggio);
                }
            }
        }); 
    },	

    //frazioni:1,2,3,4,6,12
    generaArrayTime : function(oraInizio,oraFine,frazioni){
        var arr = new Array();
        for (var i = oraInizio ; i < oraFine ; i++){
            for (var j = 0 ; j < frazioni ; j++){
                var f = j * (60/frazioni);
                var ora = i < 10 ? "0"+i : i;
                var minuti = f < 10 ? "0"+f : f;
                arr.push(ora+":"+minuti);
            }
        }
        return arr;
    },

    downloadFile: function(api, args, filename = "download", onComplete = null) {
        args.SESSION_TOKEN = global.utils.SESSION_TOKEN;
        const url = global.utils.BASE_API + api;
        if (typeof global.filters?.openPopUp === 'function') {
            global.filters.openPopUp('modalLoading');
        }
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(args)
        })
        .then(response => {
            if (!response.ok) throw new Error('Errore nella risposta');
            return response.blob();
        })
        .then(blob => {
            const contentType = blob.type;
            const extension = contentType.includes('zip') ? '.zip'
                : contentType.includes('excel') ? '.xlsx'
                : contentType.includes('pdf') ? '.pdf'
                : '';

            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = blobUrl;
            a.download = filename + extension;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(blobUrl);
        })
        .catch(err => {
            console.error("Errore nel download:", err);
            global.utils.alert.danger("Errore nel download.");
        })
        .finally(() => {
            if (typeof global.filters?.closePopUp === 'function') {
                global.filters.closePopUp('modalLoading');
            }
            if (typeof onComplete === 'function') onComplete();
        });
    },

    generateRandomString(length){
        let result = "", seeds
    
        for(let i = 0; i < length - 1; i++){
            //Generate seeds array, that will be the bag from where randomly select generated char
            seeds = [
                Math.floor(Math.random() * 10) + 48,
                Math.floor(Math.random() * 25) + 65,
                Math.floor(Math.random() * 25) + 97
            ]
            
            //Choise randomly from seeds, convert to char and append to result
            result += String.fromCharCode(seeds[Math.floor(Math.random() * 3)])
        }
    
        return result
    },

    navIsOpen : false,

    /* Set the width of the side navigation to 250px */
    openNav(selector = '#mySidenav') {
        return;
        if (global.utils.navIsOpen == false){
            setTimeout(() => {
                global.utils.navIsOpen = true;            
            }, 200);
            global.$(selector).css("right","0px");
        }
    },

    /* Set the width of the side navigation to 0 */
    closeNav() {
        return;
        global.utils.navIsOpen = false;
        global.$('.sidenav').css("right","-640px");
    },

    wait : (_handler,time = 300) => {
        setTimeout(() => {
            _handler();          
        }, time);
    }, 
    
    valutaRecapito(destinatario,tipo,flgServer){
        var recapito = destinatario.TELEFONO;
        var recapito2 = destinatario.RECAPITO_2;
        var recapito3 = destinatario.RECAPITO_3;
        var DESTINAZIONE = "";
        var email = destinatario.EMAIL;
        var stato = 0;
        var errore = "";
        //SMS
        if (tipo == 1){
            if (flgServer == 0){
                recapito = destinatario.DESTINAZIONE;
            }
            if (recapito != null && recapito.length > 0){
                recapito = recapito.replace(" ","");
                recapito = recapito.replace("-","");
                recapito = recapito.replace("/","");
                if ( (recapito2 != null && recapito2.length > 0) || (recapito3 != null && recapito3.length > 0)){
                    stato = 1;
                    errore = "Più numeri di telefono in anagrafica";
                }
                else if (recapito.length > 10){
                    stato = 1;
                    errore = "Il formato del campo RECAPITO 1 potrebbe essere errato";
                }
                else if (recapito.charAt(0) == '0'){
                    stato = 1;
                    errore = "Il numero impostato potrebbe essere un numero fisso";
                }
                DESTINAZIONE = recapito;
            }
            else{
                if ( (recapito2 != null && recapito2.length > 0) || (recapito3 != null && recapito3.length > 0)){
                    if ((recapito2 != null && recapito2.length > 0) && (recapito3 != null && recapito3.length > 0)){
                        stato = 1;
                        errore = "Più numeri di telefono in anagrafica";
                    }
                    else{
                        if (recapito2 != null && recapito2.length > 0){
                            if (recapito2.length > 10){
                                stato = 1;
                                errore = "Il formato del campo RECAPITO 2 potrebbe essere errato";
                            }
                            else{
                                DESTINAZIONE = recapito2;
                            }
                        }
                        else if (recapito3 != null && recapito3.length > 0){
                            if (recapito3.length > 10){
                                stato = 1;
                                errore = "Il formato del campo RECAPITO 3 potrebbe essere errato";
                            }
                            else{
                                DESTINAZIONE = recapito3;
                            }
                        }
                    }
                }
                else{
                    stato = 1;
                    errore = "RECAPITO 1 non presente";
                }
            }				
        }
        else{
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (flgServer == 0){
                email = destinatario.DESTINAZIONE;
            }
            if (email == null || email.length == 0){
                stato = 1;
                errore = "Email non definita";
            }
            else{
                if (re.test(email) == false){
                    stato = 1;
                    errore = "Formato email non corretto";
                }
                DESTINAZIONE = email;
                                
            }
        }
        return {STATO:stato,ERRORE:errore,DESTINAZIONE:DESTINAZIONE};
    },

    array : {
        getMax : function (_array, nomeCampo) {
            var max = 0;
            for (var i = 0 ; i < _array.length ; i++) {
                if (nomeCampo == undefined) {
                    if (_array[i] > max) {
                        max = _array[i];
                    }
                }
                else {
                    if (_array[i][nomeCampo] > max) {
                        max = _array[i][nomeCampo];
                    }
                }
            }
            return max;
        },


        getMin : function (_array, nomeCampo) {
            var min = 9007199254740992;
            for (var i = 0 ; i < _array.length ; i++) {
                if (nomeCampo == undefined) {
                    if (_array[i] < min) {
                        min = _array[i];
                    }
                }
                else {
                    if (_array[i][nomeCampo] < min) {
                        min = _array[i][nomeCampo];
                    }
                }
            }
            return min;
        },


        sumByField : function (_array, nomeCampo) {
            var somma = 0;
            for (var i = 0 ; i < _array.length ; i++) {
                if (nomeCampo == undefined) {
                    somma += parseFloat(_array[i]);
                }
                else {
                    somma += parseFloat(_array[i][nomeCampo]);
                }
            }
            return somma;
        },

        sumByFieldSigned : function (_array, nomeCampo, signField) {
            var somma = 0;
            for (var i = 0; i < _array.length; i++) {
                var v = parseFloat(_array[i][nomeCampo] || 0);
                somma += (_array[i][signField] === 0 ? -v : v);
            }
            return somma;
        },

        raggruppaArray : function (arrayColl,
            groupField,
            descrizioneField,
            nomeCampoDescrizionePadre,
            nomeCampoArrayFigli,
            flgNumerico,
            flgDesc){

                if (flgNumerico == undefined){
                    flgNumerico = false;
                }
                if (flgDesc == undefined){
                    flgDesc = false;
                }
                var arrayGrouped = new Array();
                arrayColl = global.utils.array.ordinaArray(arrayColl, groupField);
                var arrayColl2 = new Array();
                for (var z = 0 ; z < arrayColl.length ; z++) {
                    arrayColl2.push(arrayColl[z]);
                }
                var valGroupField = '';

                for (var i = arrayColl2.length -1 ; i> -1 ; --i){
                    var item = arrayColl2[i];
                    if (item[groupField] != valGroupField){
                        valGroupField = item[groupField];
                        var padre = new Object();
                        padre[nomeCampoDescrizionePadre] = item[groupField];
                        padre[nomeCampoArrayFigli] = new Array();
                        arrayGrouped.push(padre);
                        arrayColl2.splice(i,1);
                    }
                    else{
                        arrayColl2.splice(i,1);
                    }
                    item = null;
                }
                for (let i = 0 ; i<arrayGrouped.length ; i++){
                    let padre = arrayGrouped[i];
                    for (var k = arrayColl.length - 1 ; k>-1 ; --k){
                        if (arrayColl[k][groupField] == padre[nomeCampoDescrizionePadre]){
                            padre[nomeCampoArrayFigli].push(arrayColl[k]);
                            arrayColl.splice(k,1);
                            if (k == -1){
                                break;
                            }
                        }
                        else{
                            break;
                        }
                    }
                }
                return arrayGrouped;
        },

        ordinaArray : function(array, key){
            return array.sort(function(a, b) {
                var x = a[key];
                var y = b[key];
                if (typeof x === "string")
                {
                    try{
                        x = x.toLowerCase();
                        y = y.toLowerCase();
                    }
                    catch (e){
                        console.log("ecception")
                    }
                    
                }

                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            });
        },

        /**
         * Sorts an array of objects by column/property.
         * @param {Array} array - The array of objects.
         * @param {object} sortObject - The object that contains the sort order keys with directions (asc/desc). e.g. { age: 'desc', name: 'asc' }
         * @returns {Array} The sorted array.
         * 
         * 
         * //console.log('sorted by Age (desc), Name (asc), Years (desc):', multiSort(data, {
                age: 'desc',
                name: 'asc',
                years: 'desc'
            }));
         */
        multiSort : function(array, sortObject = {}) {
            const sortKeys = Object.keys(sortObject);

            // Return array if no sort object is supplied.
            if (!sortKeys.length) {
                return array;
            }

            // Change the values of the sortObject keys to -1, 0, or 1.
            for (let key in sortObject) {
                sortObject[key] = sortObject[key] === 'desc' || sortObject[key] === -1 ? -1 : (sortObject[key] === 'skip' || sortObject[key] === 0 ? 0 : 1);
            }

            const keySort = (a, b, direction) => {
                direction = direction !== null ? direction : 1;

                if (a === b) { // If the values are the same, do not switch positions.
                    return 0;
                }

                // If b > a, multiply by -1 to get the reverse direction.
                return a > b ? direction : -1 * direction;
            };

            return array.sort((a, b) => {
                let sorted = 0;
                let index = 0;

                // Loop until sorted (-1 or 1) or until the sort keys have been processed.
                while (sorted === 0 && index < sortKeys.length) {
                    const key = sortKeys[index];

                    if (key) {
                        const direction = sortObject[key];

                        sorted = keySort(a[key], b[key], direction);
                        index++;
                    }
                }

                return sorted;
            });
        },

        distinct : function (_array,  _id, _desc) {
            var arrayNew = new Array();
            for (var i = 0 ; i < _array.length ; i++) {
                var controllo = false;
                for (var j = 0 ; j < arrayNew.length ; j++) {
                    if (_array[i][_id] == arrayNew[j][_id]) {
                        controllo = true;
                        break;
                    }
                }
                if (controllo == false) {
                    var item = new Object();
                    item[_id] = _array[i][_id];
                    if (_array[i][_desc] != undefined) {
                        item[_desc] = _array[i][_desc];
                    }
                    arrayNew.push(item);
                }
            }
            return arrayNew;
        },


        select : function (_array, _key, _val, _count) {
            var arrayNew = new Array();
            for (var i = 0 ; i < _array.length ; i++) {
                if (_array[i][_key] == _val) {
                    arrayNew.push(_array[i]);
                }
                if (_count != undefined && arrayNew.length == _count) {
                    return arrayNew;
                }
            }
            return arrayNew;
        },

        getItemIndex : function (_array, _key, _val) {
            for (var i = 0 ; i < _array.length ; i++) {
                if (_array[i][_key] == _val) {
                    return i;
                }                
            }
            return -1;
        },


        selectEval : function (_array, condition, _count) {
            var arrayNew = new Array();
            for (var i = 0 ; i < _array.length ; i++) {
                var item = _array[i]
                if (eval(condition) == true) {
                    arrayNew.push(item);
                }
                if (_count != undefined && arrayNew.length == _count) {
                    return arrayNew;
                }
            }
            return arrayNew;
        },

        toSelect2 : function(_array,_id,_text){
            var arrayNew = new Array();
            for (var i = 0 ; i < _array.length ; i++) {
                var item = _array[i]
                arrayNew.push({
                    id:item[_id],text:item[_text]
                });
            }
            return arrayNew;
        },
        toId : function(_array,id){
            var arr = new Array();
            for (var i = 0 ; i < _array.length ; i++) {
                arr.push(_array[i][id]);
            }
            return arr;
        }
    },

    notify : function(c,a,s,delay){0==global.$(".toast-container").length&&global.$("<div>",{class:"toast-container","aria-live":"polite","aria-atomic":"true"}).appendTo(document.body);var e=global.$(".toast-container"),t=c,i=null,l=a,v=s;switch(t){case"info":i='<svg viewBox="0 0 448 512"><path fill="#f8f9fa" d="M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-176 86c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"/></svg>';break;case"warning":i='<svg viewBox="0 0 576 512"><path fill="#343a40" d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"/></svg>';break;case"success":i='<svg viewBox="0 0 512 512"><path fill="#f8f9fa" d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"/></svg>';break;case"error":i='<svg viewBox="0 0 512 512"><path fill="#f8f9fa" d="M497.9 150.5c9 9 14.1 21.2 14.1 33.9v143.1c0 12.7-5.1 24.9-14.1 33.9L361.5 497.9c-9 9-21.2 14.1-33.9 14.1H184.5c-12.7 0-24.9-5.1-33.9-14.1L14.1 361.5c-9-9-14.1-21.2-14.1-33.9V184.5c0-12.7 5.1-24.9 14.1-33.9L150.5 14.1c9-9 21.2-14.1 33.9-14.1h143.1c12.7 0 24.9 5.1 33.9 14.1l136.5 136.4zM377.6 338c4.7-4.7 4.7-12.3 0-17l-65-65 65.1-65.1c4.7-4.7 4.7-12.3 0-17L338 134.4c-4.7-4.7-12.3-4.7-17 0l-65 65-65.1-65.1c-4.7-4.7-12.3-4.7-17 0L134.4 174c-4.7 4.7-4.7 12.3 0 17l65.1 65.1-65.1 65.1c-4.7 4.7-4.7 12.3 0 17l39.6 39.6c4.7 4.7 12.3 4.7 17 0l65.1-65.1 65.1 65.1c4.7 4.7 12.3 4.7 17 0l39.4-39.8z"/></svg>';break;case"other":i='<svg class="fa-spin" viewBox="0 0 512 512"><path fill="#f8f9fa" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"/></svg>';break;case"facebook":i='<svg viewBox="0 0 448 512"><path fill="#f8f9fa" d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"/></svg>';break;case"github":i='<svg viewBox="0 0 496 512"><path fill="#f8f9fa" d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"/></svg>';break;case"instagram":i='<svg viewBox="0 0 448 512"><path fill="#f8f9fa" d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg>';break;case"linkedin":i='<svg viewBox="0 0 448 512"><path fill="#f8f9fa" d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"/></svg>';break;case"paypal":i='<svg viewBox="0 0 384 512"><path fill="#f8f9fa" d="M111.4 295.9c-3.5 19.2-17.4 108.7-21.5 134-.3 1.8-1 2.5-3 2.5H12.3c-7.6 0-13.1-6.6-12.1-13.9L58.8 46.6c1.5-9.6 10.1-16.9 20-16.9 152.3 0 165.1-3.7 204 11.4 60.1 23.3 65.6 79.5 44 140.3-21.5 62.6-72.5 89.5-140.1 90.3-43.4.7-69.5-7-75.3 24.2zM357.1 152c-1.8-1.3-2.5-1.8-3 1.3-2 11.4-5.1 22.5-8.8 33.6-39.9 113.8-150.5 103.9-204.5 103.9-6.1 0-10.1 3.3-10.9 9.4-22.6 140.4-27.1 169.7-27.1 169.7-1 7.1 3.5 12.9 10.6 12.9h63.5c8.6 0 15.7-6.3 17.4-14.9.7-5.4-1.1 6.1 14.4-91.3 4.6-22 14.3-19.7 29.3-19.7 71 0 126.4-28.8 142.9-112.3 6.5-34.8 4.6-71.4-23.8-92.6z"/></svg>';break;case"skype":i='<svg viewBox="0 0 448 512"><path fill="#f8f9fa" d="M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8 0-113.5-91.9-205.3-205.3-205.3-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2-2.9 14-4.7 28.9-4.7 43.8 0 113.5 91.9 205.3 205.3 205.3 14.9 0 29.7-1.7 43.8-4.7 19 14.6 42.6 23.3 68.2 23.3 61.8 0 112-50.2 112-112 .1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65 0-16 9-30.6 29.5-30.6 31.2 0 34.1 44.9 88.1 44.9 25.7 0 42.3-11.4 42.3-26.3 0-18.7-16-21.6-42-28-62.5-15.4-117.8-22-117.8-87.2 0-59.2 58.6-81.1 109.1-81.1 55.1 0 110.8 21.9 110.8 55.4 0 16.9-11.4 31.8-30.3 31.8-28.3 0-29.2-33.5-75-33.5-25.7 0-42 7-42 22.5 0 19.8 20.8 21.8 69.1 33 41.4 9.3 90.7 26.8 90.7 77.6 0 59.1-57.1 86.5-112 86.5z"/></svg>';break;case"twitter":i='<svg viewBox="0 0 512 512"><path fill="#f8f9fa" d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"/></svg>';break;case"wikipedia":i='<svg viewBox="0 0 640 512"><path fill="#f8f9fa" d="M640 51.2l-.3 12.2c-28.1.8-45 15.8-55.8 40.3-25 57.8-103.3 240-155.3 358.6H415l-81.9-193.1c-32.5 63.6-68.3 130-99.2 193.1-.3.3-15 0-15-.3C172 352.3 122.8 243.4 75.8 133.4 64.4 106.7 26.4 63.4.2 63.7c0-3.1-.3-10-.3-14.2h161.9v13.9c-19.2 1.1-52.8 13.3-43.3 34.2 21.9 49.7 103.6 240.3 125.6 288.6 15-29.7 57.8-109.2 75.3-142.8-13.9-28.3-58.6-133.9-72.8-160-9.7-17.8-36.1-19.4-55.8-19.7V49.8l142.5.3v13.1c-19.4.6-38.1 7.8-29.4 26.1 18.9 40 30.6 68.1 48.1 104.7 5.6-10.8 34.7-69.4 48.1-100.8 8.9-20.6-3.9-28.6-38.6-29.4.3-3.6 0-10.3.3-13.6 44.4-.3 111.1-.3 123.1-.6v13.6c-22.5.8-45.8 12.8-58.1 31.7l-59.2 122.8c6.4 16.1 63.3 142.8 69.2 156.7L559.2 91.8c-8.6-23.1-36.4-28.1-47.2-28.3V49.6l127.8 1.1.2.5z"/></svg>';break;case"youtube":i='<svg viewBox="0 0 576 512"><path fill="#f8f9fa" d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"/></svg>';break;case"spinner":i='<svg class="fa-spin" viewBox="0 0 512 512"><path fill="#f8f9fa" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"/></svg>';break;default:i='<i style="width:35px;height:35px" class="fas fa-'+t+'"></i>'}global.$("<div>",{class:"toast","data-autohide":"true","data-delay":delay,"data-type":t,role:"alert","aria-live":"assertive","aria-atomic":"true"}).html('<div class="toast-content"><div class="toast-icon">'+i+'</div><div class="toast-body"><strong>'+l+"</strong><div>"+v+'</div></div></div><button class="close" type="button" data-dismiss="toast" aria-label="Close"><span><svg class="svg-inline--fa fa-times fa-w-11 fa-fw fa-xs" focusable="false" data-prefix="fas" data-icon="times" style="width:0.8em" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512" data-fa-i2svg=""><path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg></span></button>').appendTo(e).toast("show"),global.$(".toast").on("hidden.bs.toast",function(){global.$(this).toast("dispose").remove()})}
    ,mergeObjects : function(objects,merge = null,overwrite = 1){
        if (merge == null){
            merge = {}
        }
        for (var k = 0 ; k < objects.length ; k++){
            var item = objects[k];
            if (item == undefined){
                continue;
            }
            var arr = Object.keys(item);
            for (var i = 0 ; i < arr.length ; i++){
                if (!merge.hasOwnProperty(arr[i]) || overwrite == 1){
                    merge[arr[i]] = item[arr[i]];                   
                }
            }
        }
        return merge;
    },
    google:{
        importaPlace(place,model){
            //route,street_number,administrative_area_level_2

            var componentForm = new Array({google:'route',travel:'INDIRIZZO',target:'long_name'},
                                            {google:'postal_code',travel:'CAP',target:'short_name'},
                                            {google:'street_number',travel:'CIVICO',target:'short_name'},
                                            {google:'administrative_area_level_2',travel:'PROV',target:'short_name'},
                                            {google:'locality',travel:'CITTA',target:'short_name'}
                                        );

            model.LATITUDINE = place.geometry.location.lat();
            model.LONGITUDINE = place.geometry.location.lng();
            for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];
                for (var j = 0 ; j < componentForm.length ; j++){
                    if (componentForm[j].google == addressType) {
                        var val = place.address_components[i][componentForm[j].target];
                        model[componentForm[j].travel] = val;
                        break;
                    }
                }
            }
            return model;
        }
    },

    // GESTIONE PERMESSI E FUNZIONALITA
    permissions: {
        /**
         * Verifica se l'utente loggato ha una specifica funzionalità
         * @param {string} azione - Il codice azione della funzionalità (es: 'PROGETTO_MODIFICA', 'PROGETTO_ELIMINA')
         * @returns {boolean} true se l'utente ha il permesso, false altrimenti
         */
        hasFunzionalita(azione) {
            if (!global.sprint || !global.sprint._instance || !global.sprint._instance.proxy || !global.sprint._instance.proxy.$root) {
                return false;
            }
            const utente = global.sprint._instance.proxy.$root.utente;
            if (!utente || !utente.funzionalita || utente.funzionalita.length === 0) {
                return false;
            }
            return utente.funzionalita.some(f => f.AZIONE === azione);
        },

        /**
         * Verifica se l'utente loggato ha una specifica funzionalità tramite ID
         * @param {number} idFunzionalita - L'ID della funzionalità
         * @returns {boolean} true se l'utente ha il permesso, false altrimenti
         */
        hasFunzionalitaById(idFunzionalita) {
            if (!global.sprint || !global.sprint._instance || !global.sprint._instance.proxy || !global.sprint._instance.proxy.$root) {
                return false;
            }
            const utente = global.sprint._instance.proxy.$root.utente;
            if (!utente || !utente.funzionalita || utente.funzionalita.length === 0) {
                return false;
            }
            return utente.funzionalita.some(f => f.ID_FUNZIONALITA === idFunzionalita);
        },

        /**
         * Verifica se l'utente loggato ha TUTTE le funzionalità specificate
         * @param {string[]} azioni - Array di codici azione
         * @returns {boolean} true se l'utente ha tutti i permessi, false altrimenti
         */
        hasAllFunzionalita(azioni) {
            return azioni.every(azione => this.hasFunzionalita(azione));
        },

        /**
         * Verifica se l'utente loggato ha ALMENO UNA delle funzionalità specificate
         * @param {string[]} azioni - Array di codici azione
         * @returns {boolean} true se l'utente ha almeno un permesso, false altrimenti
         */
        hasAnyFunzionalita(azioni) {
            return azioni.some(azione => this.hasFunzionalita(azione));
        },

        /**
         * Ottiene tutte le funzionalità dell'utente loggato
         * @returns {Array} Array di funzionalità
         */
        getFunzionalita() {
            if (!global.sprint || !global.sprint._instance || !global.sprint._instance.proxy || !global.sprint._instance.proxy.$root) {
                return [];
            }
            const utente = global.sprint._instance.proxy.$root.utente;
            return (utente && utente.funzionalita) ? utente.funzionalita : [];
        },

        /**
         * Mostra un messaggio di errore se l'utente non ha il permesso
         * @param {string} messaggio - Messaggio personalizzato (opzionale)
         */
        showPermissionDenied(messaggio = "Non hai i permessi necessari per eseguire questa operazione") {
            global.utils.alert.warning(messaggio);
        },

        /**
         * Verifica il permesso e mostra un messaggio se non ce l'ha
         * @param {string} azione - Il codice azione della funzionalità
         * @param {string} messaggio - Messaggio personalizzato (opzionale)
         * @returns {boolean} true se ha il permesso, false altrimenti
         */
        checkAndNotify(azione, messaggio) {
            const hasPermission = this.hasFunzionalita(azione);
            if (!hasPermission) {
                this.showPermissionDenied(messaggio);
            }
            return hasPermission;
        }
    },

    notifiche: {
        invia: function(context, titolo, testo) {
            var modulo = context.filters.getModuloCorrente(context.$root.$route.path);
            if (!modulo || !modulo.ICONA) return;
            var idModuloOpzione = parseInt(modulo.ID_OPZIONE_TIPOLOGICA);
            var idModuloIcona   = parseInt(modulo.ICONA);
            var tipologia = (context.$root.arrayNotificheTipologie || []).find(function(t) {
                return t.AZIONE === titolo && parseInt(t.FK_ID_MODULO) === idModuloOpzione;
            });
            if (!tipologia) return;
            utils.ajax('shared/notifica/insert', {
                DESCRIZIONE: testo,
                FK_ID_MODULO: idModuloIcona,
                FK_ID_ENTE: context.$root.idEnteCorrente,
                FK_ID_TIPOLOGIA: tipologia.ID_TIPOLOGIA_NOTIFICA,
                FK_ID_OPERAZIONE: 0,
                FK_ID_UTENTE: context.$root.utente.ID_UTENTE
            }, function(res) {
                if (res.esito == 0) {
                    context.$root.appoggio.socket.emit('moduleEvent', {
                        FK_ID_MODULO: idModuloOpzione,
                        FK_ID_TIPOLOGIA: tipologia.ID_TIPOLOGIA_NOTIFICA,
                        FK_ID_UTENTE: context.$root.utente.ID_UTENTE
                    });
                }
            }, false);
        }
    }


};


//module.exports = utils;
exports.utils = utils;